import { adminHttpClient } from '../../commons/adminHttpClient'
import OrderedPageFilter from '../../commons/orderedPageFilter'
import PagedList from '../../commons/PagedList'

export interface PagedMigrationLog extends PagedList<MigrationLog> {}

export interface MigrationLog {
  id: string
  eventType: MigrationLogEventType
  message: string
  createdAt: Date
}

export enum MigrationLogEventType {
  MigrationStarted = 0,
  Information = 1,
  Error = 2,
  MigrationFailed = 3,
  MigrationCompletedSuccessfully = 4,
}

export interface MigrationLogsFilter extends OrderedPageFilter {
  companyId: string
}

const getMigrationLogs = (filter: MigrationLogsFilter): Promise<any> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 20,
    orderColumn: 'createdAt',
    orderDescending: true,
  }

  return adminHttpClient.get('/csi/MigrationLogs', filter)
}

export default getMigrationLogs
